export interface IntegrationRequestToken {
    organizationKey: string;
    organizationName: string;
    userKey: string;
    userEmail: string;
    redirectUrl: string;
    integrationType: string;
    token: string;
}


export enum IntegrationTypes {
    studentAuth = 'studentAuth',
    schoolAuth = 'schoolAuth',
} 